<template>
  <main>
    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-75 md-small-size-100">
        <h2 class="md-title">料金シミュレーション(改定後料金)</h2>
      </div>
    </div>
    <div class="md-layout md-alignment-center" v-if="errorMessages.length">
      <div class="md-layout-item md-size-75 md-small-size-100">
        <flash-message :errors="errorMessages"></flash-message>
      </div>
    </div>
    <div class="md-layout md-alignment-center">
      <md-card class="md-layout-item md-size-75 md-small-size-100">
        <md-card-header>
          <div class="md-title">
            何名でご利用ですか
            <md-button class="md-icon-button md-dense" v-on:click="showSnackbar = true">
              <md-icon>help_outline</md-icon>
            </md-button>
          </div>
          <div class="md-corp-num md-size-100 md-small-size-100 md-caption">適格請求書発行事業者 登録番号：T9-0111-0104-7870</div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100">ユーザー（ID数）</div>
            <div class="step-container">
              <div class="labels">
                <div>1</div>
                <div>50</div>
                <div>100</div>
                <div>250</div>
                <div>1000</div>
              </div>
              <div class="lines">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item progress-bar">
              <input :max="CONSTS.PROGRESS_BAR.MAX"
                     :min="CONSTS.PROGRESS_BAR.MIN"
                     type="range" :disabled="sending"
                     v-model.number="form.progressBar">
            </div>
          </div>
        </md-card-content>
        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30 md-small-size-100">数量</div>
            <div class="md-layout-item md-size-30 md-small-size-80">
              <md-field class="md-field-accounts">
                <md-input :max="CONSTS.ACCOUNTS.MAX"
                          :min="CONSTS.ACCOUNTS.MIN"
                          class="md-input-accounts" :disabled="sending"
                          type="number"
                          v-model="form.numberAccount"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-20">
              <span class="md-display-1"></span>ユーザー（ID数）
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30 md-small-size-100">単価</div>
            <div class="md-layout-item md-size-30 md-small-size-80">
              <span class="md-display-1 md-layout md-alignment-center-right md-price">{{ getUnitPrice() }}</span>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-20">
              <span class="md-display-1"></span>円
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30 md-small-size-100">月額料金（税抜）</div>
            <div class="md-layout-item md-size-30 md-small-size-80">
              <span class="md-display-1 md-layout md-alignment-center-right md-price">{{ getTotalPrice() }}</span>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-20">
              <span class="md-display-1"></span>円
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30 md-small-size-100"></div>
            <div class="md-layout-item">
              <span class="md-caption">※登記情報取得を行った場合は別途、登記情報提供サービスの定める料金が発生します。料金については、登記情報提供サービスサイトをご確認ください。</span>
            </div>
          </div>
        </md-card-content>

        <md-card-actions class="md-layout">
          <div class="md-layout-item md-size-10 md-layout md-alignment-center-left">
          </div>
          <div class="md-layout-item md-size-80 md-layout md-alignment-center-center">
            <div class="md-layout">
              <div class="md-layout-item md-size-100 md-layout md-alignment-center-center">
                <span class="imc_title">＼ 15日間無料トライアル実施中 ／</span>
              </div>
              <div class="md-layout-item md-size-100 md-layout md-alignment-center-center">
                <a href="https://www.jon.co.jp/lp/index-map-cloud/" target="_blank">
                  <div class="imc_banner">
                    <div class="imc_logo">
                      <img src="https://cdn.jon-api.com/shikaku-map/img/logo_im@c.png" alt="インデックスマップ＠クラウド">
                    </div>
                    <div class="imc_text">
                      <p>シカクマップの次世代不動産登記活用プラットフォーム</p>
                      <p>「インデックスマップ@クラウド」はこちら</p>
                    </div>
                    <div>
                      〉
                    </div>
                  </div>
                </a>
              </div>
              <div class="md-layout-item md-size-100 md-layout md-alignment-center-center">
                <p>
                  ※当ページからのシカクマップ新規お申し込みは停止いたしました。<br/>
                  <a href="https://www.jon.co.jp/lp/index-map-cloud/" target="_blank">インデックスマップ@クラウド</a>でもシカクマップと同等の機能がお使いいただけます。<br/>
                  15日間無料トライアルも可能ですので是非ご検討ください。
                </p>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-10 md-layout md-alignment-center-right">
          </div>
        </md-card-actions>

        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100 md-small-size-100 ">*ご注意事項*</div>
            <div class="md-layout-item md-size-100 md-small-size-100 md-caption">
              *本契約時は１IDのみ発行されます。本契約完了後に追加でIDを発行することが可能です。
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100 md-caption">
              *本契約時は登記情報提供サービスID（法人利用）が必要です。(本サイトと登記情報提供サービスで同一IDでの重複ログインはできません)
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100 md-caption">
              *本契約後はIDを発行された月から、ID数に応じた月額が発生致します。（月の途中でのID発行・利用解除・退会があっても、月額の日割計算は行いません。）
              ただし、2ヶ月目（IDを発行された翌月）までご契約を継続されたIDの月額につきましては、1ヶ月目を無料とさせて頂きます。（無料となったID数を控除して月額が計算されます。）
              <!--キャンペーン用-->
              <!--<span class="md-attention">契約当月無料キャンペーン実施中！</span>-->
            </div>
            <div class="md-layout-item md-size-100 md-small-size-100 md-caption">*トライアル時に料金は発生しません。</div>
            <div class="md-layout-item md-size-100 md-small-size-100 md-caption">*2024年9月までのID数に応じた月額につきましては
              <router-link :to="{ name: 'Simulation' }"><a>「料金シミュレーション（改定前料金）」</a></router-link>よりご確認ください。</div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <md-snackbar class="md-snackbar" :md-active.sync="showSnackbar" :md-duration="Infinity" md-persistent>
      <span>* ご利用予定ユーザー数を入力してください。月額料金をご確認いただけます。<br>
        * ユーザー数に応じて、段階的な割引が適用されます。<br>
        * 請求単位は1ヶ月(毎月1日～末日)となります。請求時のID数は、1ヶ⽉間でID数が最⼤となった⽇を基準とします。</span>
      <md-button class="md-primary" @click="showSnackbar = false">閉じる</md-button>
    </md-snackbar>
  </main>
</template>

<script>
import FlashMessage                             from "../../components/FlashMessage";
import {apiClient, apiList}                     from '../../modules/apiClient';
import {validationMixin}                        from 'vuelidate'
import {maxLength, minValue, numeric, required} from 'vuelidate/lib/validators'
import Validation                               from "../../modules/validation";
import Common                                   from "../../modules/common";
import CommonMixin                              from "../../mixins/commonMixin";

/**
   * 定数
   */
  const CONSTS = {
    // プログレスバーの最小値,最大値
    PROGRESS_BAR: {
      MIN: 1,
      MAX: 200
    },
    // 数量の最小値,最大値
    ACCOUNTS    : {
      MIN: 1,
      MAX: 1000
    }
  };
  /**
   * ステップごとの閾値
   * @type {{STEP1: {ACCOUNTS: number, PROGRESS: number, STEP: number}}}
   */
  const STEPS  = {
    STEP1: {
      PROGRESS: 100,
      ACCOUNTS: 100,
      STEP    : 1
    },
    STEP2: {
      PROGRESS: 150,
      ACCOUNTS: 250,
      STEP    : 3
    },
    STEP3: {
      PROGRESS: 200,
      ACCOUNTS: 1000,
      STEP    : 15
    },
  };

  export default {
    name      : "Simulation2",
    components: {FlashMessage},
    mixins    : [validationMixin, CommonMixin],
    data      : () => ({
      CONSTS         : CONSTS,
      sending        : false,
      showSnackbar   : false,
      simulationPrice: 0,
      unitPrice      : 0,
      form           : {
        progressBar  : 1,
        numberAccount: 1,
      },
      errors         : {
        numberAccount: {
          required : Validation.errorMessage(Validation.rules.required, 'numberAccount'),
          min      : Validation.errorMessage(Validation.rules.min, 'numberAccount', 1),
          maxLength: Validation.errorMessage(Validation.rules.maxLength, 'numberAccount', 7),
          numeric  : Validation.errorMessage(Validation.rules.numeric, 'numberAccount'),
        }
      },
      prices         : [],
      tax            : [],
      numberAccount  : 1,
    }),
    validations() {
      return {
        form: {
          numberAccount: {
            required,
            numeric,
            minValue : minValue(1),
            maxLength: maxLength(7),
          },
        }
      };
    },
    mounted   : function () {
      this.getPrice();
    },
    watch     : {
      'form.progressBar': function () {
        const numberAccount = Math.floor(this.stepProgressToAccounts());
        if (this.numberAccount !== numberAccount) {
          this.numberAccount = numberAccount;
        }
      },
      'form.numberAccount': function () {
        if (this.numberAccount !== this.form.numberAccount) {
          this.numberAccount = Math.floor(this.form.numberAccount);
        }
      },
      numberAccount: function () {
        this.correctNumberAccount()
        const progressBar = Math.floor(this.stepAccountsToProgress());
        if (progressBar !== this.form.progressBar) {
          this.form.progressBar = progressBar;
        }
        if (this.numberAccount !== this.form.numberAccount) {
          this.form.numberAccount = Math.floor(this.numberAccount);
        }
      },
    },
    methods   : {
      /**
       * 価格情報を取得する
       */
      getPrice() {
        this.sending = true;
        apiClient.get(apiList.payment.priceAfter)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.prices = response.data.data;
            this.tax    = response.data.tax;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset();
          });
      },
      /**
       * 単価
       * @returns {?string}
       */
      getUnitPrice() {
        return Common.numberFormat(this.unitPrice);
      },
      /**
       * 総額（税抜）
       * @returns {?string}
       */
      getTotalPrice() {
        this.simulationPrice = Common.priceCalculator(this.prices, this.numberAccount);
        this.unitPrice       = Common.unitPriceCalculator(this.simulationPrice, this.numberAccount);
        const totalPrice     = Common.consumptionTaxCalculator(this.unitPrice, this.numberAccount);
        return Common.numberFormat(totalPrice);
      },
      /**
       * 数量の最小値・最大値を値を補正する
       */
      correctNumberAccount() {
        if (this.numberAccount > STEPS.STEP3.ACCOUNTS) {
          this.numberAccount = STEPS.STEP3.ACCOUNTS;
        }
        if (this.numberAccount < 1) {
          this.numberAccount = 1;
        }
      },
      /**
       * プログレスバーの値を数量へ反映する
       * @returns {number}
       */
      stepProgressToAccounts() {
        let accounts = 0;
        let progress = 0;
        let step     = STEPS.STEP1.STEP;
        if (this.form.progressBar > STEPS.STEP2.PROGRESS) {
          accounts = STEPS.STEP2.ACCOUNTS;
          progress = STEPS.STEP2.PROGRESS;
          step     = STEPS.STEP3.STEP;
        } else if (this.form.progressBar > STEPS.STEP1.PROGRESS) {
          accounts = STEPS.STEP1.ACCOUNTS;
          progress = STEPS.STEP1.PROGRESS;
          step     = STEPS.STEP2.STEP;
        }
        return accounts + ((this.form.progressBar - progress) * step);
      },
      /**
       * 数量の値をプログレスバーへ反映する
       * @returns {number}
       */
      stepAccountsToProgress() {
        let accounts = 0;
        let progress = 0;
        let step     = STEPS.STEP1.STEP;
        if (this.numberAccount > STEPS.STEP2.ACCOUNTS) {
          accounts = STEPS.STEP2.ACCOUNTS;
          progress = STEPS.STEP2.PROGRESS;
          step     = STEPS.STEP3.STEP;
        } else if (this.numberAccount >= STEPS.STEP1.ACCOUNTS) {
          accounts = STEPS.STEP1.ACCOUNTS;
          progress = STEPS.STEP1.PROGRESS;
          step     = STEPS.STEP2.STEP;
        }
        return progress + ((this.numberAccount - accounts) / step);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/components.scss";

  .md-steppers {
    height: 104px;
  }

  .md-stepper {
    padding: 0;
  }

  .md-button-height-auto {
    height: auto;
    min-height: 36px;
    padding: 10px;
  }

  .md-snackbar {
    max-width: none;
  }

  .md-field-accounts {
    min-height: 0;
    padding-top: 0;
    margin-bottom: 10px;
  }

  .md-input-accounts {
    text-align: right;
    height: 1.2em;
  }

  .md-field-accounts.md-has-value .md-input {
    font-size: 34px;
    max-width: 100%;
  }

  .md-price {
    color: #5595ff;
    padding-right: 13px;
    height: 46px;
  }

  /* プログレスバー */
  .step-container {
    width: calc(100% - 0px);
  }

  /* プログレスバーのラベル */
  .labels {
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    display: flex;
  }

  .labels > div {
    flex: 1 1 auto;
    text-align: center;
    width: calc(100% / 8);
    padding: 0 2px 0 2px;
  }

  /* プログレスバーの罫線 */
  .lines {
    margin: 0 auto;
    justify-content: center;
    flex-wrap: wrap;
    width: 80%;
    display: flex;
    height: 24px;
  }

  .lines > div {
    border-right: 1px solid gray;
    flex: 1 1 auto;
    text-align: right;
    width: calc(100% / 8);
    padding: 0;
  }

  .lines > div:first-of-type {
    border-left: 1px solid gray;
  }

  /* プログレスバー */
  .progress-bar {
    margin-top: -23px;
    justify-content: center;
    display: flex;
  }

  .progress-bar > input {
    width: calc(100% - 20% + 13px)
  }

  .md-card {
    margin-bottom: 40px;
  }

  .md-card-actions {
    margin-bottom: 40px;
  }

  .md-attention {
    color: #ff5252;
  }

  .md-card-actions {
    .md-button.md-theme-default.md-raised {
      width: 80%;

      &.md-theme-default {
        background-color: orange;
        color: rgba(255, 255, 255, 1);
        color: var(--md-theme-default-text-primary-on-background, rgba(255, 255, 255, 1));
      }
    }
  }

  .md-icon.md-theme-default.md-icon-font {
    color: rgba(255, 255, 255, 1);
    color: var(--md-theme-default-text-primary-on-background, rgba(255, 255, 255, 1));
  }

  .md-corp-num {
    position: absolute;
    top: 0;
    right: 0;
    padding: 15px;
  }

  .imc_banner {
    display: flex;
    align-items: center;
    background: linear-gradient(to right, rgb(2, 106, 185), rgb(0, 165, 213));
    height: 100px;
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
    border-radius: 4px;
    color: white;
    font-weight: bold;
  }

  .imc_banner:hover {
    background: linear-gradient(to right, rgb(2, 116, 195), rgb(0, 175, 223)); /* マウスオーバー時に背景色を少し明るく */
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4); /* マウスオーバー時に影を追加 */
    cursor: pointer; /* マウスオーバー時にカーソルを指マークに変更 */
  }

  .imc_title {
    font-size: 18px;
    font-weight: 400;
    padding-top: 20px;
    padding-bottom: 5px;
    font-family: Roboto, Noto Sans, -apple-system, BlinkMacSystemFont, sans-serif;
  }

  .imc_logo {
    flex: 0 0 20%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .imc_text {
    flex: 1;
    padding-left: 20px;

    p {
      margin: 0;
      line-height: 1.5;
      font-size: 1.2em;
    }
  }
  
</style>
